import React from 'react'
import {
  List, Datagrid, TextField, EditButton, Create, SimpleForm,
  BooleanInput, SelectField, SelectInput, TextInput, Edit, ReferenceInput
} from 'admin-on-rest'

import CreateMoneyButton from '../components/createMoneyTransfer'
import MonetaryField from '../components/monetaryField'
import constants from '../utils/constants'

const states = constants.states
const required = value => value ? undefined : 'O Horário é obrigatório!'

const styles = {
  noPadding: {
    padding: 0
  }
}

const validateGasStations = (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = ['O Nome é obrigatório!']
  }
  if (!values.email) {
    errors.email = ['O Email é obrigatório!']
  }
  if (!values.address) {
    errors.address = ['O Endereço é obrigatório!']
  }
  if (!values.postalCode) {
    errors.postalCode = ['O CEP é obrigatório!']
  }
  if (!values.city) {
    errors.city = ['A Cidade é obrigatória!']
  }
  if (!values.state) {
    errors.state = ['O Estado é obrigatório!']
  }
  if (!values.latitude) {
    errors.latitude = ['A Latitude é obrigatória!']
  }
  if (!values.longitude) {
    errors.longitude = ['A Longitude é obrigatória!']
  }
  if (!values.photoUrl) {
    errors.photoUrl = ['A Imagem é obrigatória!']
  }
  return errors
}
const zero = <span> 0 </span>
const ChargedFeeField = ({ record = {} }) =>
  <span>
    {isNaN(record.chargedFee) ? zero : record.chargedFee} %
  </span>
ChargedFeeField.defaultProps = { label: 'TAXA' }

export const GasStationList = (props) => (

  <List {...props} title='Postos'>
    <Datagrid>
      <TextField label='Nome' source='name' />
      <TextField label='Cidade' source='city' />
      <TextField label='Estado' source='state' />
      <SelectField source='status' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'}
      ]}
      />
      <MonetaryField label='TOTAL' source='receivables.total' />
      <MonetaryField label='PAGO' source='receivables.paid' />
      <MonetaryField label='REPASSE' source='receivables.debt' />
      <MonetaryField label='LITROZ' source='receivables.litroz' />
      <ChargedFeeField label='TAXA' source='chargedFee' />
      <CreateMoneyButton style={styles.noPadding} />
      <EditButton />
    </Datagrid>
  </List>
)

export const GasStationCreate = (props) => (
  <Create {...props} title='Criar Posto'>
    <SimpleForm validate={validateGasStations}>
      <SelectInput source='status' label='Status' defaultValue='active' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'}
      ]}
      />
      <ReferenceInput label='Super Administrador' source='superAdminUser' reference='user' perPage={100}>
        <SelectInput optionText='email' optionValue='_id' />
      </ReferenceInput>
      <TextInput label='Nome' source='name' />
      <TextInput label='e-Mail' source='email' />
      <TextInput label='Endereço' source='address' />
      <TextInput label='CEP' source='postalCode' />
      <TextInput label='Cidade' source='city' />
      <SelectInput label='Estado' source='state' choices={states} />
      <TextInput label='Latitude' source='latitude' />
      <TextInput label='Longitude' source='longitude' />
      <TextField label='Horário de Funcionamento: ' />
      <TextField label='Segunda-feira' />
      <TextInput label='Abertura' source='operatingHours.monday.opens' validate={required} />
      <TextInput label='Fechamento' source='operatingHours.monday.closes' validate={required} />
      <TextField label='Terça-feira' />
      <TextInput label='Abertura' source='operatingHours.tuesday.opens' validate={required} />
      <TextInput label='Fechamento' source='operatingHours.tuesday.closes' validate={required} />
      <TextField label='Quarta-feira' />
      <TextInput label='Abertura' source='operatingHours.wednesday.opens' validate={required} />
      <TextInput label='Fechamento' source='operatingHours.wednesday.closes' validate={required} />
      <TextField label='Quinta-feira' />
      <TextInput label='Abertura' source='operatingHours.thursday.opens' validate={required} />
      <TextInput label='Fechamento' source='operatingHours.thursday.closes' validate={required} />
      <TextField label='Sexta-feira' />
      <TextInput label='Abertura' source='operatingHours.friday.opens' validate={required} />
      <TextInput label='Fechamento' source='operatingHours.friday.closes' validate={required} />
      <TextField label='Sábado' />
      <TextInput label='Abertura' source='operatingHours.saturday.opens' validate={required} />
      <TextInput label='Fechamento' source='operatingHours.saturday.closes' validate={required} />
      <TextField label='Domingo' />
      <TextInput label='Abertura' source='operatingHours.sunday.opens' validate={required} />
      <TextInput label='Fechamento' source='operatingHours.sunday.closes' validate={required} />
      <TextInput label='Taxa' source='chargedFee' />
      <BooleanInput label='Etanol' source='fuels.ethanol.availability' />
      <BooleanInput label='Etanol Aditivado' source='fuels.premiumEthanol.availability' />
      <BooleanInput label='Gasolina' source='fuels.gas.availability' />
      <BooleanInput label='Gasolina Aditivada' source='fuels.premiumGas.availability' />
      <BooleanInput label='Diesel S10' source='fuels.diesel.availability' />
      <BooleanInput label='Diesel S500' source='fuels.dieselS500.availability' />
      <BooleanInput label='Arla' source='fuels.arla.availability' />
      <BooleanInput label='Gás Natural Veicular' source='fuels.carrierNaturalGas.availability' />
      <TextInput label='Imagem' source='photoUrl' />
    </SimpleForm>
  </Create>
  )

export const GasStationEdit = (props) => (
  <Edit {...props} title='Editar Posto'>
    <SimpleForm validate={validateGasStations}>
      <SelectInput source='status' label='Status' defaultValue='active' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'},
        {id: 'deleted', name: 'Excluído'}
      ]}
      />
      <TextInput label='Nome' source='name' />
      <TextInput label='e-Mail' source='email' />
      <TextInput label='Endereço' source='address' />
      <TextInput label='CEP' source='postalCode' />
      <TextInput label='Cidade' source='city' />
      <SelectInput label='Estado' source='state' choices={states} />
      <TextInput label='Latitude' source='latitude' />
      <TextInput label='Longitude' source='longitude' />
      <TextField label='Horário de Funcionamento:' source='' />
      <TextField label='Segunda-feira' source='' />
      <TextInput label='Abertura' source='operatingHours.monday.opens' />
      <TextInput label='Fechamento' source='operatingHours.monday.closes' />
      <TextField label='Terça-feira' source='' />
      <TextInput label='Abertura' source='operatingHours.tuesday.opens' />
      <TextInput label='Fechamento' source='operatingHours.tuesday.closes' />
      <TextField label='Quarta-feira' source='' />
      <TextInput label='Abertura' source='operatingHours.wednesday.opens' />
      <TextInput label='Fechamento' source='operatingHours.wednesday.closes' />
      <TextField label='Quinta-feira' source='' />
      <TextInput label='Abertura' source='operatingHours.thursday.opens' />
      <TextInput label='Fechamento' source='operatingHours.thursday.closes' />
      <TextField label='Sexta-feira' source='' />
      <TextInput label='Abertura' source='operatingHours.friday.opens' />
      <TextInput label='Fechamento' source='operatingHours.friday.closes' />
      <TextField label='Sábado' source='' />
      <TextInput label='Abertura' source='operatingHours.saturday.opens' />
      <TextInput label='Fechamento' source='operatingHours.saturday.closes' />
      <TextField label='Domingo' source='' />
      <TextInput label='Abertura' source='operatingHours.sunday.opens' />
      <TextInput label='Fechamento' source='operatingHours.sunday.closes' />
      <TextInput label='Taxa' source='chargedFee' />
      <BooleanInput label='Etanol' source='fuels.ethanol.availability' />
      <BooleanInput label='Etanol Aditivado' source='fuels.premiumEthanol.availability' />
      <BooleanInput label='Gasolina' source='fuels.gas.availability' />
      <BooleanInput label='Gasolina Aditivada' source='fuels.premiumGas.availability' />
      <BooleanInput label='Diesel S10' source='fuels.diesel.availability' />
      <BooleanInput label='Diesel S500' source='fuels.dieselS500.availability' />
      <BooleanInput label='Arla' source='fuels.arla.availability' />
      <BooleanInput label='Gás Natural Veicular' source='fuels.carrierNaturalGas.availability' />
      <TextField label='Etanol' source='fuels.ethanol.price' />
      <TextField label='Etanol Aditivado' source='fuels.premiumEthanol.price' />
      <TextField label='Gasolina' source='fuels.gas.price' />
      <TextField label='Aditivada' source='fuels.premiumGas.price' />
      <TextField label='Diesel S10' source='fuels.diesel.price' />
      <TextField label='Diesel S500' source='fuels.dieselS500.price' />
      <TextField label='Arla' source='fuels.arla.price' />
      <TextField label='Gás Natural Veicular' source='fuels.carrierNaturalGas.price' />
      <TextInput label='Imagem' source='photoUrl' />
    </SimpleForm>
  </Edit>
  )



// WEBPACK FOOTER //
// ./src/collections/gasStations.js